import { Container } from 'component-library';
import { ReactNode } from 'react';

import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';

export const PortfolioPageLayout = ({
  title,
  children,
  showFilters = false,
}: {
  title: string;
  children: ReactNode;
  showFilters?: boolean;
}) => {
  const menuItems = useMenuItems();

  return (
    <SignedInPageLayout
      items={menuItems}
      withCustomContentContainer
      navBarProps={{
        title,
        showFilters,
      }}
    >
      <Container gutterWidth={{ sm: 4 }} className='gap-10'>
        {children}
      </Container>
    </SignedInPageLayout>
  );
};
